import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import BonusList, { DispatchProps, OwnProps, StateProps } from './BonusList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getBonuses } from 'src/store/actions/bonus-actions';
import { getBonusesCsv } from 'src/store/actions/bonus-actions';
import { getProvidersSmall } from 'src/store/actions/provider-actions';
import { selectNameProviders } from '../../../../../../store/selectors/providers-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.bonuses.data,
        inProgress: state.bonuses.inProgress,
        providers: selectNameProviders(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getBonuses(params)),
        getDataCsv: (params: QueryParams) => dispatch(getBonusesCsv(params)),
        getProviders: (params: QueryParams) => dispatch(getProvidersSmall(params)),
    };
}

const BonusListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(BonusList);

export default BonusListScreen;
